// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__w-I_I","insightsList":"newBusinessInsightsMenu_insightsList__2sYV5","active":"newBusinessInsightsMenu_active__2SlxT"};